export const LOADING_START = 'LOADING_START';
export const LOADING_FINISH = 'LOADING_FINISH';
export const DISPLAY_ERROR_OPEN = 'DISPLAY_ERROR_OPEN';
export const DISPLAY_ERROR_CLOSE = 'DISPLAY_ERROR_CLOSE';
export const RESET_SNACKBAR = 'RESET_SNACKBAR';
export const SET_IS_MOBILE = 'SET_IS_MOBILE';
export const SET_LAST_BREADCRUMB = 'SET_LAST_BREADCRUMB';
export const UPDATE_RESPONSIVE = 'UPDATE_RESPONSIVE';



// WEBPACK FOOTER //
// ./src/store/modules/application/types.js